import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LOCALE_EN } from '../../constant';

const PreferencesListSelectBlock = ({ children, itemsManager }) => {
    const { i18n } = useTranslation();
    const [count, setCount] = useState(0);

    const getSelectedValues = () => {
        setCount(itemsManager.getSelectedList().length);
    };

    useEffect(() => {
        itemsManager.registerFiltersChangingObserver(getSelectedValues);
        getSelectedValues();
        return () => {
            itemsManager.unRegisterFiltersChangingObserver(getSelectedValues);
        };
    }, []);

    const getPreferenceForm = (count) => {
        if(i18n.resolvedLanguage === LOCALE_EN) {
            return count > 0 ? 'preferences' : 'preference';
        } else {
            if (count > 10 && [11, 12, 13, 14].includes(count % 100)) return 'предпочтений';
            let last_num = count % 10;
            if (last_num == 1) return 'предпочтение';
            if ([2, 3, 4].includes(last_num)) return 'предпочтения';
            if ([5, 6, 7, 8, 9, 0].includes(last_num)) return 'предпочтений';
        }
    };

    const createCountPhrase = (count) => {
        return `${i18n.t('app.page.preference.total')} ${count} ${getPreferenceForm(count)}`;
    };



    return (
        <div className="preference__selected">
            <p className="block__content">
                {createCountPhrase(count)}
            </p>
            <div className="preference__button-group">
                {children}
            </div>
        </div>
    );
};

export default PreferencesListSelectBlock;
